import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import { houseClassColors, HouseClasses } from './ListItem.model';

const StyledHoverBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s ease;
	z-index: 1;

	background-image: radial-gradient(
		circle at center,
		rgba(255, 255, 255, 0.1) 0%,
		rgba(255, 255, 255, 0) 100%
	);
`;

const StyledContainer = styled.div<{
	$mode: 'add' | 'remove';
	$active?: boolean;
	$selectionHidden?: boolean;
}>`
	position: relative;
	display: grid;
	grid-template-columns: ${(props) =>
		props.$mode === 'add' ? '1fr auto auto' : '20px 1fr auto auto'};
	align-items: center;
	column-gap: 20px;
	width: 100%;
	height: 70px;

	& > img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}

	& > ${Text} {
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
	}

	&:hover {
		${StyledHoverBackground} {
			opacity: 1;
		}
	}

	${(props) =>
		props.$active &&
		!props.$selectionHidden &&
		css`
			${StyledHoverBackground} {
				opacity: 1;
			}
		`}
`;

const StyledInfoContainer = styled.div`
	display: flex;
	column-gap: 10px;
	z-index: 2;
`;

const StyledInfoButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 30px;
	height: 30px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		width: 16px;
		height: 16px;
		opacity: 0.5;
		user-select: none;
		pointer-events: none;
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			opacity: 1;
			filter: invert(100%);
		}
	}
`;

const StyledHintDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: #000000;
	opacity: 0.1;
`;

const StyledHintContainer = styled.div<{ $mode: 'add' | 'remove' }>`
	position: absolute;
	${(props) =>
		props.$mode === 'add' &&
		css`
			right: -15px;
		`}
	${(props) =>
		props.$mode === 'remove' &&
		css`
			right: 20px;
		`}
	z-index: 4;
	width: 300px;
	padding: 22px 20px 20px;
	background-color: #ffffff;
	border-radius: 10px;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.hint-enter {
		opacity: 0;
	}

	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		opacity: 1;
	}

	&.hint-exit-active {
		opacity: 0;
	}
`;

const StyledHintInfoContainer = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	row-gap: 10px;
	justify-content: space-between;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;
		color: #000000;
	}

	& ${Text}:nth-child(2n + 1) {
		opacity: 0.5;
	}

	& ${Text}:nth-child(2n) {
		text-align: right;
	}
`;

const StyledHintHeading = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledHouseClassContainer = styled.div<{ $class: HouseClasses }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 6px;
	background-color: ${(props) => houseClassColors[props.$class].bg};

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: ${(props) => houseClassColors[props.$class].text};
	}
`;

export {
	StyledContainer,
	StyledHintContainer,
	StyledHintDivider,
	StyledHintHeading,
	StyledHintInfoContainer,
	StyledHouseClassContainer,
	StyledHoverBackground,
	StyledInfoButtonContainer,
	StyledInfoContainer,
};
